export const loc = {
	sv: {
		mobile: "Använd två fingrar för att flytta kartan",
		desktop: "Använd Ctrl + scrolla för att zooma kartan",
		desktopMac: "Använd ⌘ + scrolla för att zooma kartan",
		openMap: "Visa kartan",
		findInMap: "Hitta i kartan",
		filterLabel: "Filter",
		of: "av",
		clear: "Rensa",
		show: "Visa",
		altitudeUnitM: "m ö.h.",
		altitudeUnitFt: "ft ö.h.",
	},
	en: {
		mobile: "Use two fingers to move the map",
		desktop: "Use Ctrl + scroll to zoom the map",
		desktopMac: "Use ⌘ + scroll to zoom the map",
		openMap: "Show map",
		findInMap: "Find in map",
		filterLabel: "Filter",
		of: "of",
		clear: "Clear",
		show: "Show",
		altitudeUnitM: "m asl",
		altitudeUnitFt: "ft asl",
	},
	no: {
		mobile: "Bruk to fingre for å flytte kartet",
		desktop: "Bruk Ctrl + scroll for å zoome kartet",
		desktopMac: "Bruk ⌘ + scroll for å zoome kartet",
		openMap: "Vis kart",
		findInMap: "Finn i kart",
		filterLabel: "Filter",
		of: "av",
		clear: "Tøm",
		show: "Vis",
		altitudeUnitM: "moh",
		altitudeUnitFt: "ft o.h.",
	},
	fi: {
		mobile: "Use two fingers to move the map",
		desktop: "Use Ctrl + scroll to zoom the map",
		desktopMac: "Use ⌘ + scroll to zoom the map",
		openMap: "Show map",
		findInMap: "Find in map",
		filterLabel: "Suodatin",
		of: "/",
		clear: "Tyhjennä",
		show: "Näytä",
		altitudeUnitM: "m mpy",
		altitudeUnitFt: "ft mpy",
	},
	nl: {
		mobile: "Gebruik twee vingers om de kaart te verplaatsen",
		desktop: "Gebruik Ctrl + scroll om de kaart te zoomen",
		desktopMac: "Gebruik ⌘ + scroll om de kaart te zoomen",
		openMap: "Toon kaart",
		findInMap: "Zoek op de kaart",
		filterLabel: "Filter",
		of: "van",
		clear: "Wissen",
		show: "Toon",
		altitudeUnitM: "m asl",
		altitudeUnitFt: "ft asl",
	}
}
